import { render } from "./VanityGen.vue?vue&type=template&id=3b1304b6"
import script from "./VanityGen.vue?vue&type=script&setup=true&lang=js"
export * from "./VanityGen.vue?vue&type=script&setup=true&lang=js"

import "./VanityGen.vue?vue&type=style&index=0&id=3b1304b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/VanityGen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b1304b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b1304b6', __exports__)) {
    api.reload('3b1304b6', __exports__)
  }
  
  module.hot.accept("./VanityGen.vue?vue&type=template&id=3b1304b6", () => {
    api.rerender('3b1304b6', render)
  })

}


export default __exports__